// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Slugs in this file are primarily used for
// tracking purpose. Please be mindful if a
// change to a slug is needed
const slugPrefix = 'coaching-intro-modal';

export const CoachingIntrolModalData = {
  slug: slugPrefix,
  slides: [
    {
      slug: 'kudos-slide',
      title: 'Kudos',
      imageWidth: '185px',
      imageBgColor: Colors.purple[25],
      image: Illustrations.kudo_example,
      description: `It's never been easier to celebrate wins. Kudos makes it fun and easy to thank each other for a job well done. Use gifs, video recordings, or your own words to share recognition with your whole team.`,
    },
    {
      slug: 'feedback-slide',
      title: 'Feedback',
      imageBgColor: Colors.purple[25],
      imageWidth: '245px',
      image: Illustrations.feedback_example,
      description:
        'Strengthen team performance with continuous feedback. Send feedback with your own words, video recordings, or try our feedback templates.',
    },
    {
      slug: 'feedback-ai-slid',
      title: 'Feedback AI',
      imageBgColor: Colors.purple[25],
      imageWidth: '240px',
      image: Illustrations.feedback_ai_example,
      description:
        'Giving great feedback can be difficult and time-consuming. Break the blank page problem with advanced AI that generates thoughtful feedback with just a few clicks.',
    },
    {
      slug: 'feedback-ai-slid',
      title: 'Celebrate wins & boost team morale',
      imageBgColor: Colors.purple[25],
      image: Illustrations.high_fiving_purple_bg,
      imageWidth: '200px',
      description: 'Now you’re ready to start exchanging feedback and lightweight kudos to build stronger teams!.',
      nextBtnLabel: 'Give Feedback/Kudos',
    },
  ],
} as NewFeatureCarouselModalType;
